import * as React from 'react';

import { UserCommissionRepository } from '../../MedicareProAPI/Repositories/User/UserCommissionRepository';
import { PlanRepository } from '../../MedicareProAPI/Repositories/PlanRepository';
import { Utilities } from '../../MedicareProAPI/Utilities/Utilities';
import ProfileNotesLogsCalls from '../Components/ProfileNotesLogsCalls';
import ProfileNotesLogsSMS from '../Components/ProfileNotesLogsSMS';
import ProfileNotesLogs from '../Components/ProfileNotesLogs';
import { UserEmailActivity } from '../Components/EmailActivity/UserEmailActivity';
import type { Ind } from '../../MedicareProAPI/Entities/Ind/Ind';
import { PROFILE_LOG_PORTAL_TAB_LABELS } from '../Language/en';
import { IntegrationManager } from '../Components/IntegrationManager';
import type { INTEGRATION_TYPE } from '../Constants/Integrations';
import { INTEGRATION_OPTIONS } from '../Constants/Integrations';

export enum PROFILE_LOG_TAB {
  CALL_LOG = 0,
  SMS_LOG = 1,
  OTHER_LOGS = 2,
  EMAIL_LOG = 3,
}

export interface ProfileLogPanelProps {
  ind: Ind;
}

export const ProfileNotesLogsPanel = (props: any): React.JSX.Element => {
  console.log(props.ind);
  const [selectedSection, setSelectedSection] = React.useState<PROFILE_LOG_TAB>(
    PROFILE_LOG_TAB.CALL_LOG
  );
  const [properties, setProperties] = React.useState(props);

  const [showIntegrationSetup, setShowIntegrationSetUp] = React.useState<boolean>(false);
  const [allowedIntegrationServices, setAllowedIntegrationServices] = React.useState<string[]>([]);
  const handleSetUpIntegrationHide = () => {
    setShowIntegrationSetUp(false);
  };

  const onSetupClick = (serviceType: INTEGRATION_TYPE) => {
    setAllowedIntegrationServices([...INTEGRATION_OPTIONS[serviceType]]);
    setShowIntegrationSetUp(true);
  };

  return (
    <>
      <IntegrationManager
        userAccessToken={props.userAccessToken}
        userId={props.userId}
        showIntegrationSetup={showIntegrationSetup}
        onHide={handleSetUpIntegrationHide}
        allowedServices={allowedIntegrationServices}
      />

      <div className="card pn-0">
        <div className="card-header mb-3">
          Logs{' '}
          <i
            className="far fa-info-circle cp"
            data-toggle="popover"
            data-content="Logs are generated by integrated VoIP and texting services or internal automations or other activities. If you don't wish to see logs, click the toggle switch in the notes section."
          ></i>
        </div>
        <div className="card-body pb-0 callLogList" id="callLogList">
          <div className="mb-2">
            {PROFILE_LOG_PORTAL_TAB_LABELS.map((tab) => {
              const classList = ['badge', 'badge-sm', 'border', 'border-info', 'mr-1', 'cp'];

              if (tab.value === selectedSection) {
                classList.push('badge-info');
              }

              return (
                <div onClick={(e) => setSelectedSection(tab.value)} className={classList.join(' ')}>
                  {tab.label}
                </div>
              );
            })}
          </div>

          <div className="mt-2">
            {!properties.indId && (
              <p className="alert alert-info small">
                Loading... <i className="fas fa-spinner fa-spin"></i>
              </p>
            )}
            {properties.indId && (
              <>
                {selectedSection === PROFILE_LOG_TAB.CALL_LOG && (
                  <ProfileNotesLogsCalls
                    {...properties}
                    onSetupClick={(serviceType) => onSetupClick(serviceType)}
                  />
                )}
                {selectedSection === PROFILE_LOG_TAB.SMS_LOG && (
                  <ProfileNotesLogsSMS
                    {...properties}
                    onSetupClick={(serviceType) => onSetupClick(serviceType)}
                  />
                )}
                {selectedSection === PROFILE_LOG_TAB.OTHER_LOGS && (
                  <ProfileNotesLogs {...properties} />
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
